module.exports = __webpack_public_path__ + "static/media/logoICBF.5f0bf178.svg";